import { IncorporacaoBloco } from "../../../../domain/models/incorporacao_bloco";
import { IncorporacaoBlocoItem } from "./incorporacao_bloco_item";

/**
 * IncorporacaoBlocoLista
 */

type Props = {
  incorporacaoBlocoLista: IncorporacaoBloco[],
};

export const IncorporacaoBlocoLista = ({
  incorporacaoBlocoLista,
}: Props) => {
  return (
    <div className="flex flex-col text-black dark:text-white items-center gap-4 mx-auto">
      {
        incorporacaoBlocoLista.map(x => (
          <IncorporacaoBlocoItem
            key={x.idIncorporacaoBloco}
            incorporacaoBloco={x} />
        ))
      }
    </div>
  );
}